
import { Component, HostListener, inject, OnInit, OnDestroy } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GlobalService } from './services/global.service';
import { VideoManagementSseService } from '../modules/shared/services/video-management-sse.service';
import { D2XAuthService } from '../modules/d2x-client/services/d2x-auth.service';

declare global {
  interface Window {
    electronAPI: {
      downloadVideo: (options: { url: string, filename: string }) => void;
      openExternalLink: (url: string) => void;
    };
  }
}
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  private videoManagementSseService = inject(VideoManagementSseService);
  private snackbar = inject(MatSnackBar);
  private authService = inject(D2XAuthService);
  
  title = 'Adlight';

  // constructor(private electronMessageService: ElectronMessageService) {}

  updateMessage: string | null = null;
  showRestart = false;
  globalService = inject(GlobalService);

  ngOnInit() {
    console.log('AppComponent ngOnInit');
    const sessionId = this.authService.getSessionId();
    if (!sessionId) {
      console.warn('[AppComponent] sessionId가 없어 SSE 연결 시작 불가');
      return;
    }
    this.videoManagementSseService.connect(sessionId);

    this.videoManagementSseService.message$.subscribe({
      next: (data) => {
        console.log('AppComponent 메시지:', data);
        if (data.type === 'done') {
          this.snackbar.open(`프로젝트 ${data.project_id} 영상 생성이 완료되었습니다.`, '', { duration: 3000, horizontalPosition: 'center', verticalPosition: 'top' });
        } else if (data.type === 'error') {
          this.snackbar.open(`프로젝트 ${data.project_id} 영상 생성 중 오류가 발생했습니다.`, '', { duration: 3000, horizontalPosition: 'center', verticalPosition: 'top' });
        }
      },
      error: (err) => {
        console.error('SSE 메시지 스트림 에러:', err);
      }
    });


    // console.log('environment', environment.isElectronBuild);
    // console.log('environment', environment.baseUrl);


    // this.electronMessageService.on('update_available', () => {
    //   this.updateMessage = 'A new update is available. Downloading...';
    // });

    // this.electronMessageService.on('update_downloaded', () => {
    //   this.updateMessage = 'Update downloaded. Restart to apply.';
    //   this.showRestart = true;
    // });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    // console.log('window resize event', window.innerWidth);
    this.globalService.setWindowInnerSize(window.innerWidth, window.innerHeight);
  }

  ngOnDestroy(): void {
    console.log('AppComponent ngOnDestroy -> disconnect SSE');
    this.videoManagementSseService.disconnect();
  }
  
  // 브라우저 닫힘, 새로고침 시 안전한 연결 종료
  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(event: Event) {
    this.videoManagementSseService.disconnect();
  }
}
